import { SelectPendingPayment } from '../../select/SelectPendingPayment';

const NewPendingPaymentRelation = ({ onSubmit }) => {
  function handleSubmit(paymentReminder) {
    onSubmit({ paymentReminder, type: 'paymentReminder' });
  }

  return (
    <SelectPendingPayment
      apiUrl={'payment-reminders?openVolume[gt]=0'}
      onSelect={handleSubmit}
      hasOpenAmount
    />
  );
};

export default NewPendingPaymentRelation;
